// MobileMenuButton.jsx

import React from 'react';

// Utilities
import { formatCount } from 'utilities/Formatters';

// CSS
import './MobileMenuButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * MobileMenuButton Component
 * 
 * This component renders a button to the app bar.
 * 
 * @param {component} icon The icon component to render.
 * @param {string} iconKey Icon key to render via Icon.
 * @param {string} title The title of the button.
 * @param {boolean} selected The selected state of the button.
 * @param {boolean} enabled Whether the button is interactive.
 * @param {component} selectedIcon The icon component to render when selected.
 * @param {string} selectedIconKey Icon key to render when selected.
 * @param {function} onClick The function to call when the button is clicked.
 * 
 * @returns {ReactNode} The rendered component.
 */
const MobileMenuButton = ({
    icon: IconComponent,
    iconKey,
    size = 29,
    color,
    endColor,
    title,
    selected = false,
    enabled = true,
    selectedIcon: SelectedIconComponent,
    selectedIconKey,
    onClick,
    count = 0
}) => {

    // Determine which icon to use based on the selected state
    const useSelectedKey = selected && selectedIconKey;
    const useSelectedComponent = selected && SelectedIconComponent;

    const iconToUseKey = useSelectedKey ? selectedIconKey : iconKey;
    const IconToUse = useSelectedComponent ? SelectedIconComponent : IconComponent;

    // ----- HANDLERS ----- //

    /**
 * Handles click.
 */

    const handleClick = () => {
        if (!enabled) return;
        onClick && onClick();
    };
    // ----- RENDER ----- //

    return (

        <div
          className="mobile-menu-button-container"
          style={{
                cursor: enabled ? 'pointer' : 'not-allowed',
                opacity: enabled ? 1 : 0.45,
            }}
          title={title}
        >

            {/* CIRCLE */}
            <div
              className="mobile-menu-button-circle"
              onClick={handleClick}
            >

                {iconToUseKey ? (
                    <Icon
                      iconKey={iconToUseKey}
                      color={color}
                      endColor={endColor}
                      width={size}
                      height={size}
                    />
                ) : (
                    <IconToUse
                      color={color}
                      endColor={endColor}
                      width={size}
                      height={size}
                    />
                )}

            </div>

            {/* COUNT */}
            {count > 0 &&

                <div
                  className="mobile-menu-button-count"
                  style={{
                        backgroundColor: 'red',
                        borderColor: "#00000044",
                        color: "white"
                    }}
                >
                    {formatCount(count)}
                </div>
            }
        </div>

    );
};

// Dev Tools
MobileMenuButton.displayName = 'MobileMenuButton';

export default MobileMenuButton;
